import axios from "axios";
import { Toast } from 'vant';

const service = axios.create({
    baseURL: 'https://vip.digitalspark.fund:8000/api',
    timeout: 20000,
    validateStatus: function (status) {
        // 接受所有状态码，不抛出错误
        return status >= 200 && status < 600;
    }
});

service.interceptors.request.use(
    config => {
        config.headers['authorization'] = 'Bearer ' + (localStorage.getItem('token') || '');
        return config;
    },
    error => {
        return Promise.reject(new Error(error));
    }
);

service.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        // 网络错误或超时
        Toast('网络请求失败');
        return Promise.reject(error);
    }
);

export default service;
